import { render } from "./RecentlyViewedCarousel.vue?vue&type=template&id=27b8db16&scoped=true"
import script from "./RecentlyViewedCarousel.vue?vue&type=script&lang=js"
export * from "./RecentlyViewedCarousel.vue?vue&type=script&lang=js"

import "./RecentlyViewedCarousel.vue?vue&type=style&index=0&id=27b8db16&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b8db16"]])

export default __exports__